'use strict'

import Vue from 'vue'

import SlimDialog from 'v-slim-dialog'
import 'v-slim-dialog/dist/v-slim-dialog.css'

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

const AlertModal = require("./components/" + DEVICE + "/AlertModal").default

/**
 * アラート・モーダルUI Class
 */
class AlertModalUI {
    /**
     * vueインスタンス
     * @type {vue}
     * @private
     */
    v

    /**
     * コンストラクタ
     * @constructor
     */
    constructor() {
        if (!this.v) {
            Vue.use(VueToast)
            Vue.use(SlimDialog)
            Vue.use(Loading)

            let vObj = new Vue({
                el: '#alertmodal',
                template: '<AlertModal ref="alertmodal"/>',
                components: { AlertModal }
            })
            this.v = vObj.$refs['alertmodal']
        }
    }

    /**
     * ローディングを表示
     * @returns {void}
     */
    setLoading() {
        this.v.setLoading()
    }

    /**
     * ローディングを終了
     * @returns {void}
     */
    removeLoading() {
        this.v.removeLoading()
    }

    /**
     * アラートを表示
     * @param {string} str 表示する文字列
     * @param {string} type One of success, info, warning, error, default
     * @returns {void}
     */
    showAlert(str, type) {
        this.v.showAlert(str, type)
    }

    /**
     * アラートを表示（success表示）
     * @param {string} str 表示する文字列
     * @returns {void}
     */
    showAlertSuccess(str) {
        this.v.showAlertSuccess(str)
    }

    /**
     * アラートを表示（error表示）
     * @param {string} str 表示する文字列
     * @returns {void}
     */
    showAlertErr(str) {
        this.v.showAlertErr(str)
    }

    /**
     * モーダルダイアログを表示
     * @param {string} str 表示する文字列
     * @returns {void}
     */
    showDialog(str) {
        return this.v.showDialog(str)
    }
}

const alertmodal = new AlertModalUI()
export default alertmodal
